import { ApiConfig } from '../../../Config.js';
import axios from 'axios';


var RegisterMerchantCtrl = function (fn, er, state, ids) {
	
	var config = {
		headers: {
			//'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		cell: state.numtel,
  		codVat: state.piva,
  		codZip: state.capsocieta,
  		companyCode: state.codsocieta,
  		name: state.nome,
  		surname: state.cognome,
		taxCode: state.codicefiscale,
		email: state.email,
		captcha: state.captcha
	};

	axios
		.post(ApiConfig.url.REGISTER_MERCHANT, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { RegisterMerchantCtrl };